import { Box } from '@mui/material';
import { useDeleteMedia } from 'features/media/delete';
import { MediaList, useMedia } from 'entities/media/media-list';
import { MediaListFilter } from 'features/media/media-filter';
import { usePagingParams } from 'shared/hooks/paging-params';
import { useSearchParams } from 'react-router-dom';


type Props = {
  mediaId: number;
};

export const MediaCities = ({ mediaId }: Props) => {
  const [paging, setPaging] = usePagingParams();
  const [searchParams] = useSearchParams();

  const getMediaRelatedSearchParams = () => {
    const relatedFields = ['cityId'];
    const newParams = new URLSearchParams();
    [...searchParams.entries()].forEach(([key, value]) => {
      if (relatedFields.includes(key)) {
        newParams.append(key, value);
      }
    });
    return newParams;
  };

  const collection = useMedia(mediaId, paging, getMediaRelatedSearchParams());

  const deleteMedia = useDeleteMedia();

  return (
    <Box mt={2}>
      <Box mb={1}>
        <MediaListFilter 
          withMediaTypeSearch={false} 
          withCitiesSearch={true} 
          withGeoFieldSearch={false}
        />
      </Box>

      <MediaList 
        collection={collection} 
        paging={paging} 
        onChangePaging={setPaging} 
        onMediaDeleteClick={deleteMedia} 
      />
    </Box>
  );
};
